@if (state$ | async; as state) {
  <div class="page-header">
    <div class="page-title">Wysyłki</div>

    <div class="header-toolbar">
      <a class="btn" [routerLink]="['/shipments', 'new']">+ Nowa wysyłka</a>
    </div>
  </div>

  <!-- the count line and the table with its header row are the layout; the rows and the count are
       the data, drawn as shadows until it lands (0128) -->
  <div class="list-count">
    @if (state.loading) {
      <span class="shadow"></span>
    } @else if (state.shipments) {
      {{ state.shipments.length }} wys.
    }
  </div>

  <div class="list-table">
    <div class="list-row list-row-header shipment-row">
      <div class="list-cell"></div>
      <div class="list-cell">Numer</div>
      <div class="list-cell">Transport</div>
      <div class="list-cell">Data</div>
      <div class="list-cell">Status</div>
      <div class="list-cell">Zamówienia</div>
      <div class="list-cell list-cell-right">Pozycje</div>
    </div>

    @if (state.loading) {
      <!-- five rows of the page's own row, at its height: the 28px photo slot holds it (0128) -->
      @for (row of shadowRows; track row) {
        <div class="list-row list-row-shadow shipment-row">
          <div class="shadow shadow-photo"></div>
          <div class="list-cell"><span class="shadow shadow-short"></span></div>
          <div class="list-cell"><span class="shadow shadow-long"></span></div>
          <div class="list-cell"><span class="shadow shadow-short"></span></div>
          <div class="list-cell"><span class="shadow shadow-short"></span></div>
          <div class="list-cell"><span class="shadow"></span></div>
          <div class="list-cell list-cell-right"><span class="shadow shadow-short"></span></div>
        </div>
      }
    } @else if (state.shipments) {
      @for (shipment of state.shipments; track shipment.id) {
        <a class="list-row shipment-row" [routerLink]="['/shipments', shipment.id]">
          <order-face [photos]="shipment.photos"></order-face>
          <div class="list-cell shipment-row-number text-mono">{{ shipment.shipmentNumber }}</div>
          <div class="list-cell shipment-row-transport" [title]="shipment.transport">{{ shipment.transport }}</div>
          <div class="list-cell shipment-row-date text-mono">{{ shipment.plannedDateLabel ?? '—' }}</div>
          <div class="list-cell shipment-row-status">{{ shipment.statusLabel }}</div>
          <div class="list-cell shipment-row-orders text-mono" [title]="shipment.clientOrdersLabel">{{ shipment.clientOrdersLabel }}</div>
          <div class="list-cell list-cell-right shipment-row-items text-mono">{{ shipment.itemCount }} poz.</div>
        </a>
      } @empty {
        <div class="list-empty">Brak wysyłek — zacznij od dodania nowej wysyłki.</div>
      }
    }
  </div>
}
